import { StatelessComponent } from 'react'
import * as cn from 'classnames'
import * as styles from 'styles/atoms/preloaders/PageLoadingOverlay.css'
import { connect } from 'react-redux'
import { State } from 'interfaces/state'
import { isShrunkSidebarUrl } from 'helpers/pageHelpers'
import Spinner from 'components/features/pfm/Spinner/Spinner'
import { currentUrlSelector, isAuthenticatedSelector } from 'selectors/globalSelectors'
import { withRouter, RouteComponentProps } from 'react-router-dom'

type PageLoadingOverlayProps = {
  // TODO @rendalf consider slidLeft on one-column pages
  slidLeft: boolean
}

const PageLoadingOverlayComponent: StatelessComponent<PageLoadingOverlayProps> = ({ slidLeft }) => (
  <div className={ cn(styles.pageLoadingOverlay, { [styles.slidLeft]: slidLeft }) }>
    <Spinner size='large' />
  </div>
)

type PageLoadingOverlayInnerOwnProps = RouteComponentProps<{}>

const mapStateToProps = (state: State, ownProps: PageLoadingOverlayInnerOwnProps) => ({
  slidLeft: isShrunkSidebarUrl(
    currentUrlSelector(state, ownProps),
    Boolean(isAuthenticatedSelector(state))
  ),
})

const PageLoadingOverlayInner = connect(mapStateToProps)(PageLoadingOverlayComponent)
const PageLoadingOverlay = withRouter(PageLoadingOverlayInner)

export default PageLoadingOverlay
